<app-message
    [severity]="mapSeverity()"
    [closable]="true"
    closeButtonTooltip="Segna come letta"
    (onClose)="setRead()"
>
        <div class="mr-3 flex-grow-1">
            @switch (notification().notificationType) {
                @case (notificationTypes.CalendarEvent) {
                    <app-calendar-notification
                        [notification]="notification()"></app-calendar-notification>
                }
                @default {
                    <app-base-notification [notification]="notification()"></app-base-notification>
                }
            }
        </div>
</app-message>
